module.exports = __webpack_public_path__ + "img/clock_red.7ec676e1.svg";